import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Button, Skeleton } from '@mui/material';

import useClasses from '../../../../../hooks/legacy/useClasses';

import styles from './RestaurantsCarousel.style';

function LeftHeroSection({ restaurant }) {
  const classes = useClasses(styles);

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(0, 0, 0, 0.60)',
          borderRadius: 5,
          padding: 2,
        }}
      >
        <Stack
          direction="column"
          spacing={{ xs: 2, md: 3 }}
          maxWidth="md"
          alignItems="center"
        >
          <Typography variant="h2" color="white" textAlign="center">
            {restaurant.title}
          </Typography>
          <Typography variant="h6" color="white" textAlign="center">
            {restaurant.sub}
          </Typography>
          <Link to="/menu">
            <Button
              variant="contained"
              data-test-id="order-online"
              className={classes.button}
            >
              {restaurant.btn}
            </Button>
          </Link>
        </Stack>
        {restaurant?.logo ? (
          <Box
            component="img"
            src={
              restaurant.logo?.includes('https')
                ? restaurant.logo
                : `https:${restaurant.logo}`
            }
            className={classes.logoImg}
            borderRadius={5}
            marginLeft={5}
          />
        ) : (
          <Skeleton variant="rectangular" width="150" height="150" />
        )}
      </Box>
    </Box>
  );
}

LeftHeroSection.propTypes = {
  restaurant: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    sub: PropTypes.string,
    btn: PropTypes.string,
    logo: PropTypes.string,
  }),
};

LeftHeroSection.defaultProps = {
  restaurant: {},
};

export default LeftHeroSection;
